<template>
  <div>
    <div class="index"  v-if="indexShow">
      <el-container>
        <el-header id="top">
          <div class="container nav"
          v-bind:class="{ 'navActive': scrollFlag }">
            
            <el-menu
              :default-active="activeIndex"
              class="el-menu-demo"
              mode="horizontal"
                 
              @select="handleSelect"
            
              >
              <div class="logo"><img src="../assets/logo.png" ></div>
              <el-menu-item index="6" class="hr" @click="toRecruit">诚聘英才</el-menu-item>
              <el-menu-item index="5" @click="toBg6">联系我们</el-menu-item>
              <el-menu-item index="4" @click="toBg5">软件著作权</el-menu-item>
              <el-menu-item index="3" @click="toBg4">合作伙伴</el-menu-item>
              <el-menu-item index="2" @click="toBg3">业务介绍</el-menu-item>
              <el-menu-item index="1" @click="toTop">首页</el-menu-item>
              
            </el-menu>
          </div>
          <div class="scrollbg" v-if="scrollFlag"></div>
          <div class="container bg1txt">
            <div class="bg1txtl">诚获信赖  信赢精彩</div>
            <div  class="bg1txts">我们是一家面向金融行业提供技术服务的高科技企业，定位服务于中国银联、
              <br>
              
              商业银行、支付机构及其它大型互联网平台与金融机构。</div>

            <div class="button" @click="goAboutUs">&nbsp;&nbsp;更多关于我们</div>
          </div>
        </el-header>
        <el-main>
          <div class="background1">
            <div class="container bg2"  >
              <div class="bg2con" >
                <div class="bg2conlogo">
                  <img src="../assets/icon_a_01.png" >
                </div>
                <div class="bg2contitle">
                  支付业务
                </div>
                <div class="bg2contxt">
                  为满足各商业银行、收单机构开展针对商户的支付清结算类业务而设计，基本特点为：上线速度快，灵活、高效，适用于各种支付场景，能轻松满足商户的复杂清结算要求。
                  <br>
                  <br>
                  相关产品：代收付系统、 互联网支付系统、 银行卡收单系统、 聚合支付系统。
                </div>
                <div class="bg2conbtn" @click="goProduct">相关产品</div>
              </div>
              <div class="bg2con" >
                <div class="bg2conlogo">
                  <img src="../assets/icon_a_02.png" >
                </div>
                <div class="bg2contitle">
                  资金业务
                </div>
                <div class="bg2contxt">
                  借助银联交易流水确认支付机构在途资金，并进行相应质押，由商业银行出资为机构提供一定额度的短期贷款业务。
                  <br>
                  <br>
                  相关产品：D0业务系统、 D0.5业务系统。
                </div>
                <div class="bg2conbtn" @click="goProduct">相关产品</div>
              </div>
              <div class="bg2con" >
                <div class="bg2conlogo">
                  <img src="../assets/icon_a_03.png" >
                </div>
                <div class="bg2contitle">
                  其他业务
                </div>
                <div class="bg2contxt">
                  相关产品：综合验证系统、信用卡还款系统、银行卡发卡系统、信贷管理系统、便民缴费系统。
                </div>
                <div class="bg2conbtn" @click="goProduct">相关产品</div>
              </div>
            </div>
            <div class="container bg3" id="bg3">
              <div class="bg3title">
               <img src="../assets/title_01.png" >
              </div>
              <div class="bg3txt">
                经过长期的积累，已形成一系列针对互联网金融、互联网支付行业的涵盖支付业务、资金业务、数据业务等领域的综合性解决方案。各类金融支付类解决方案正服务于近百家相关机构，已经成为市面上相关解决方案权威提供商。
              </div>
              <transition name="el-fade-in-linear">
              <div class="bg3con" v-show="bg2show1">
                <div class="bg3img">
                  <img src="../assets/banner_01.png" >
                </div>
                <div class="bg3box" >
                  <div class="bg3boxtitle"><span class="line"></span><span>云捷算(T1代付)</span></div>
                  <div class="bg3boxtxt">是为合作方提供资金代付服务。内容转接平台根据合作方代付指令，实现7*24*365天的快速高效精准的完成包括对公账户、对私账户（个人银行卡账号、存折）的实时资金代付服务。</div>
                  <div class="bg3boxbtn" @click="goProduct">查看详情</div>
                  <div class="togglebtn">
                    <div class="toggletxt">{{"0"+bg2Index}}/<span style="color:#afb1b5">03</span></div>
                    <div class="toggleicon">
                      <a class="toggleleft" @click="toggleLeft(bg2Index)"><img src="../assets/button_l2.png" ></a>
                      <a class="toggleright" @click="toggleRight(bg2Index)"><img src="../assets/button_r2.png" ></a>
                    </div>
                  </div>
                </div>
              </div>
              </transition>
              <transition name="el-fade-in-linear">
              <div class="bg3con" v-show="bg2show2">
                <div class="bg3img">
                  <img src="../assets/banner_02.png" >
                </div>
                <div class="bg3box" >
                  <div class="bg3boxtitle"><span class="line"></span><span>T0/D0.5(垫资)</span></div>
                  <div class="bg3boxtxt">T0/D0.5业务为中国银联浙江分公司联合商业银行共同向合作机构提供的代付增值服务。通过整合中国银联贷记业务及商业银行资金服务，更好的满足合作机构及时向收单商户开展资金结算的需求。</div>
                  <div class="bg3boxbtn" @click="goProduct">查看详情</div>
                  <div class="togglebtn">
                    <div class="toggletxt">{{"0"+bg2Index}}/<span style="color:#afb1b5">03</span></div>
                    <div class="toggleicon">
                      <a class="toggleleft" @click="toggleLeft(bg2Index)"><img src="../assets/button_l1.png" ></a>
                      <a class="toggleright" @click="toggleRight(bg2Index)"><img src="../assets/button_r1.png" ></a>
                    </div>
                  </div>
                </div>
              </div>
              </transition>
              <transition name="el-fade-in-linear">
              <div class="bg3con" v-show="bg2show3">
                <div class="bg3img">
                  <img src="../assets/banner_03.png" >
                </div>
                <div class="bg3box" >
                  <div class="bg3boxtitle"><span class="line"></span><span>数据业务</span></div>
                  <div class="bg3boxtxt">数据服务是针对互联网金融企业等在建设以银行卡跨行交易信息为核心的新金融服务产品中，在获得商户授权的情况下提供交易查询等服务。</div>
                  <div class="bg3boxbtn" @click="goProduct">查看详情</div>
                  <div class="togglebtn">
                    <div class="toggletxt">{{"0"+bg2Index}}/<span style="color:#afb1b5">03</span></div>
                    <div class="toggleicon">
                      <a class="toggleleft" @click="toggleLeft(bg2Index)"><img src="../assets/button_l1.png" ></a>
                      <a class="toggleright" @click="toggleRight(bg2Index)"><img src="../assets/button_r1.png" ></a>
                    </div>
                  </div>
                </div>
              </div>
              </transition>
            </div>
          </div>
          <div class="background2" id="bg4">
            <div class="containter bg4">
              <div class="bg4title">
               <img src="../assets/title_02.png" >
              </div>
              <div class="bg4stitle2">
                合伙伙伴包括中国银联、商业银行、第三方支付公司、大型互联网平台等近百家机构。
              </div>
            </div>
          </div>
          <div class="background3" >
            <el-carousel :interval="4000" type="card" height="560px" :autoplay="false" arrow="never">
                <el-carousel-item v-for="item in imgs" :key="item.url">
                  
                  <img class="carousel-img"  :src="item.url" >
                </el-carousel-item>
            </el-carousel>
            <div class="container bg5" id="bg5">
              <div class="bg5title">
                <img src="../assets/title_03.png" >
              </div>
              <div class="bg5con">
                <img src="../assets/software_copyright.png">
              </div>
            </div>
          </div>
          <div class="container bg6" id="bg6">
              <div class="bg6title">
               <img src="../assets/title_04.png" >
              </div>
            </div>
            <div class="map">
              
            </div>
          <div class="container bg7">
            <div class="bg7con">
              <div class="bg7logo"><img src="../assets/icon_b_01.png"></div>
              <div class="bg7title">公司地址</div>
              <div class="bg7txt">上海市浦东新区东方路2981号2层M室<br/>贵阳清钲：贵州省贵阳市观山湖区长岭北路1号贵阳国际会议展览中心二号馆、贵阳互联网金融产业园309-128</div>
            </div>
            <div class="bg7con">
              <div class="bg7logo"><img src="../assets/icon_b_02.png"></div>
              <div class="bg7title">联系电话</div>
              <div class="bg7txt">021-60936526</div>
            </div>
            <div class="bg7con">
              <div class="bg7logo"><img src="../assets/icon_b_03.png"></div>
              <div class="bg7title">传真</div>
              <div class="bg7txt">021-60936526</div>
            </div>
            <div class="bg7con">
              <div class="bg7logo"><img src="../assets/icon_b_04.png"></div>
              <div class="bg7title">E-mail</div>
              <div class="bg7txt">office@changingpay.com</div>
            </div>
          </div>
          
          
        </el-main>
        <el-footer class="footer">
          <div class="container">
              <div class="nav">
                <div class="navcon" @click="toTop">首页</div>
                <div class="navline"></div>
                <div class="navcon" @click="toBg3">业务介绍</div>
                <div class="navline"></div>
                <div class="navcon" @click="toBg4">合作伙伴</div>
                <div class="navline"></div>
                <div class="navcon long" @click="toBg5">软件著作权</div>
                <div class="navline"></div>
                <div class="navcon" @click="toBg6">联系我们</div>
                <div class="navline"></div>
                <div class="navcon" @click="toRecruit">诚聘英才</div>
                
              </div>
              <div class="copyright">
                <div class="left">
                  <div class="title1">上海清裔钲商务咨询有限公司 贵阳清钲金融科技有限公司(c)</div>
                  <div class="title2" @click="gobeian">2016-{{ currentYear }} All Rights Reserved 黔ICP备17007172号-1</div>
                </div>
                <div class="right">
                  <div class="logo"><img src="../assets/logo.png" ></div>
                </div>
                
              </div>
            </div>  
        </el-footer> 
      </el-container>
      
    </div>
    <div class="index2" v-if="!indexShow">
    <van-sticky>
      <div class="nav" v-bind:class="{ 'navActive2': scrollFlag2 }">
        <div class="left"><img src="../assets/mobile/logo@2x.png" ></div>
        <div class="right" @click="overlayshow = true"><img src="../assets/mobile/menu@2x.png" ></div>
      </div>
      <van-overlay :show="overlayshow" @click="overlayshow = false">
        <div class="wrapper" >
          <div class="nav" v-bind:class="{ 'navActive2': overlayshow }">
            <div class="left"><img src="../assets/mobile/logo@2x.png" ></div>
            <div class="right" @click="overlayshow = true"><img src="../assets/mobile/menu@2x.png" ></div>
          </div>
          <div class="navselect" @click="toTop">
            <van-icon name="arrow" /><span class="selecttxt">首页</span>
          </div>
          <div class="navselect" @click="toBg3">
            <van-icon name="arrow" />业务介绍
          </div>
          <div class="navselect" @click="toBg4">
            <van-icon name="arrow" />合作伙伴
          </div>
          <div class="navselect" @click="toBg5">
            <van-icon name="arrow" />软件著作权
          </div>
          <div class="navselect" @click="toBg6">
            <van-icon name="arrow" />联系我们
          </div>
          <div class="navselect" @click="toRecruitm">
            <van-icon name="arrow"  />诚聘英才
          </div>
        </div>
      </van-overlay>
    </van-sticky>
      <div class="header" id="top">
        <div class="aboutBtn" @click="goAboutus_m"></div>
      </div>
      <div class="con1" >
        <van-swipe :loop="false" :width="320">
          <van-swipe-item><div class="itemcon first">
            <div class="itemhead"><img src="../assets/icon_a_01.png" >  <div style="float:left" class="itemtitle">支付业务</div></div>
            <div class="itemtxt">为满足各商业银行、收单机构开展针对商户的支付清结算类业务而设计，基本特点为：上线速度快，灵活、高效，适用于各种支付场景，能轻松满足商户的复杂清结算要求。<br>
            相关产品：代收付系统、 互联网支付系统、 银行卡收单系统、 聚合支付系统。   
            <br>
            </div>
            <div class="itembtn" @click="toPro_m">相关产品</div>
          </div></van-swipe-item>
          <van-swipe-item><div class="itemcon second">
            <div class="itemhead"><img src="../assets/icon_a_01.png" >  <div style="float:left" class="itemtitle">资金业务</div></div>
            <div class="itemtxt">借助银联交易流水确认支付机构在途资金，并进行相应质押，由商业银行出资为机构提供一定额度的短期贷款业务。<br>
            相关产品：D0业务系统、 D0.5业务系统。   
            <br>
            </div>
            <div class="itembtn" @click="toPro_m">相关产品</div>
          </div></van-swipe-item>
          <van-swipe-item><div class="itemcon last">
            <div class="itemhead"><img src="../assets/icon_a_01.png" >  <div style="float:left" class="itemtitle">其他业务</div></div>
            <div class="itemtxt">相关产品：综合验证系统、信用卡还款系统、银行卡发卡系统、信贷管理系统、便民缴费系统。   
            <br>
            </div>
            <div class="itembtn" @click="toPro_m">相关产品</div>
          </div></van-swipe-item>
        </van-swipe>
      </div>
      <div class="con2" id="bg3">
        <div class="title"><img src="../assets/mobile/title_01@2x.png" ></div>
        <div class="title2">经过长期的积累，已形成一系列针对互联网金融、互联网支付行业的涵盖支付业务、资金业务、数据业务等领域的综合性解决方案。各类金融支付类解决方案正服务于近百家相关机构，已经成为市面上相关解决方案权威提供商。</div>
        <div class="con2bg"><img src="../assets/banner_01.png" ></div>
        <van-swipe :loop="false" :width="320">
          <van-swipe-item><div class="itemcon first">
            <div class="itemhead"><div class="line"></div><div class="itemtitle">云捷算(T1代付)</div></div>
            <div class="itemtxt">
              是为合作方提供资金代付服务。内容转接平台根据合作方代付指令，实现7*24*365天的快速高效精准的完成包括对公账户、对私账户（个人银行卡账号、存折）的实时资金代付服务。   
            <br>
            </div>
            <div class="itembtn" @click="toPro_m">查看详情</div>
          </div></van-swipe-item>
          <van-swipe-item><div class="itemcon second">
            <div class="itemhead"><div class="line"></div><div class="itemtitle">T0/D0.5(垫资)</div></div>
            <div class="itemtxt">
              T0/D0.5业务为中国银联浙江分公司联合商业银行共同向合作机构提供的代付增值服务。通过整合中国银联贷记业务及商业银行资金服务，更好的满足合作机构及时向收单商户开展资金结算的需求。   
            <br>
            </div>
            <div class="itembtn" @click="toPro_m">查看详情</div>
          </div></van-swipe-item>
          <van-swipe-item><div class="itemcon last">
            <div class="itemhead"><div class="line"></div><div class="itemtitle">数据业务</div></div>
            <div class="itemtxt">
              数据服务是针对互联网金融企业等在建设以银行卡跨行交易信息为核心的新金融服务产品中，在获得商户授权的情况下提供交易查询等服务。  
            <br>
            </div>
            <div class="itembtn" @click="toPro_m">查看详情</div>
          </div></van-swipe-item>
        </van-swipe>
      </div>
      <div class="con3" id="bg4">
        <div class="title"><img src="../assets/mobile/title_02@2x.png" ></div>
        <div class="title2">合伙伙伴包括中国银联、商业银行、第三方支付公司、大型互联网平台等近百家机构。</div>
        <van-swipe :loop="false" :width="320">
          <van-swipe-item><div class="itemcon first">
            <img src="../assets/mobile/bank@2x.png" >
          </div></van-swipe-item>
          <van-swipe-item><div class="itemcon second">
            <img src="../assets/mobile/ie@2x.png" >
          </div></van-swipe-item>
          <van-swipe-item><div class="itemcon last">
            <img src="../assets/mobile/payplat@2x.png" >
          </div></van-swipe-item>
        </van-swipe>
      </div>
      <div class="con4" id="bg5">
        <div class="title"><img src="../assets/mobile/title_03@2x.png" ></div>
        <div class="title2">我司均拥有独立软件著作权的软件系统</div>
        <div class="con4bg"></div>
        <div class="copyright"><img src="../assets/mobile/copyright@2x.png" ></div>
      </div>
      <div class="con5" id="bg6">
        <div class="title"><img src="../assets/mobile/title_04@2x.png" ></div>
        <div class="con5row">
          <div class="left">
            <div class="logo"><img src="../assets/mobile/icon_b_01@2x.png" ></div>
            <div class="title">公司地址</div>
            <div class="txt">上海市浦东新区东方路2981号2层M室</div>
          </div>
          <div class="right">
            <div class="logo"><img src="../assets/mobile/icon_b_02@2x.png" ></div>
            <div class="title">联系电话</div>
            <div class="txt center">021-60936526</div>
          </div>
        </div>
        <div class="con5row">
          <div class="left">
            <div class="logo"><img src="../assets/mobile/icon_b_03@2x.png" ></div>
            <div class="title" style="left:55px">传真</div>
            <div class="txt center">021-20772828</div>
          </div>
          <div class="right">
            <div class="logo"><img src="../assets/mobile/icon_b_02@2x.png" ></div>
            <div class="title" style="left:50px">E-mail</div>
            <div class="txt center">office@changingpay.com</div>
          </div>
        </div>
      </div>
      <div class="con6">
        <img src="../assets/mobile/map@2x.png" >
      </div>
      <div class="footer">
        <img src="../assets/mobile/logo@2x.png" >
        <div class="name">上海清裔钲商务咨询有限公司 贵阳清钲金融科技有限公司(c)</div>
        <div class="copyright"  @click="gobeian">2016-{{ currentYear }} All Rights Reserved 黔ICP备17007172号-1</div>
      </div>
      <!-- <div ref="wrapper" class="wrapper1">
        <ul class="cont" ref="cont">
          <li class="cont-item" v-for="item of imgs" :key="item.url">
            <div class="cont-img">
              <img class="img" :src="item.url">
            </div>
          </li>
        </ul>
      </div> -->
      
    </div>

  </div>
  
</template>

<script>

import BScroll from '@better-scroll/core'
export default {
  name: 'HelloWorld',
  data () {
    return {
      currentYear: new Date().getFullYear(),
      overlayshow:false,
      activeIndex: '1',
      scrollFlag:false,
      scrollFlag2:false,
      bg2Index:'1',
      bg2show1:true,
      bg2show2:false,
      bg2show3:false,
      imgs:[
        {url: require('../assets/slider4.png'), },
        {url: require('../assets/slider2.png'), },
        {url: require('../assets/slider3.png'), },
        {url: require('../assets/slider1.png'), },
        
        
      ],
      windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
      screenWidth: null,
      indexShow:true,

    }
  },
  
watch: {
    screenWidth: {
      handler: function (val) {
        if (val < 450) {
          this.indexShow=false
        } else {
          this.indexShow=true
        }
      },
      immediate: true,
      deep:true
    },
  },

 
  
computed: {
    // 宽度 
    scrollerWidth: function() {
      
    }
  },
  methods: {
      verScroll () {
      let width = this.imgs.length * 250 +100// 动态计算出滚动区域的大小，前面已经说过了，产生滚动的原因是滚动区域宽度大于父盒子宽度
      this.$refs.cont.style.width = width + 'px'  // 修改滚动区域的宽度
      this.$nextTick(() => {
        if (!this.scroll) {
          this.scroll = new BScroll(this.$refs.wrapper, {
            startX: 500,
            startY: 0,  // 配置的详细信息请参考better-scroll的官方文档，这里不再赘述
            click: true,
            scrollX: true,
            scrollY: false,
            eventPassthrough: 'vertical'
          })
         
          
        } else {
          this.scroll.refresh() //如果dom结构发生改变调用该方法
        }
      })
    },
    gomtop(){
      console.log(1)
    },
      gobeian(){
        window.location.href = 'https://beian.miit.gov.cn/';
      },
      goAboutUs(){
        this.$router.push('/aboutus')
      },
      goAboutus_m(){
        this.$router.push('/aboutus_m')
      },
      goProduct(){
        this.$router.push('/product')
      },
      toRecruit(){
        this.$router.push('/recruit')
      },
      toRecruitm(){
        
        this.$router.push('/recruit_m')
        
      },
      toPro_m(){
        this.$router.push('/product_m')
      },
      toTop(e){
        document.getElementById("top").scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
      },
      toBg3(){
         document.getElementById("bg3").scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
      },
      toBg4(){
        document.getElementById("bg4").scrollIntoView({behavior: "smooth", block: "start", inline: "center"});
      },
      toBg5(){
        document.getElementById("bg5").scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
      },
      toBg6(){
        document.getElementById("bg6").scrollIntoView({behavior: "smooth", block: "start", inline: "center"});
        console.log(456)
      },
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      },
      handleScroll () {
        let _this=this;
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        // console.log(scrollTop)
        if(scrollTop){
          _this.scrollFlag=true
          _this.scrollFlag2=true
        }else{
          _this.scrollFlag=false
          _this.scrollFlag2=false
        }
      },
      toggleLeft(bg2Index){
        if(bg2Index=='1'){
          this.bg2Index='3'
          this.bg2show1=false
          this.bg2show2=false
          this.bg2show3=true
        }else if(bg2Index=='2'){
          this.bg2Index='1'
          this.bg2show1=true
          this.bg2show2=false
          this.bg2show3=false
        }else{
          this.bg2Index='2'
          this.bg2show1=false
          this.bg2show2=true
          this.bg2show3=false
        }
      },
      toggleRight(bg2Index){
        if(bg2Index=='1'){
          this.bg2Index='2'
          this.bg2show1=false
          this.bg2show2=true
          this.bg2show3=false
        }else if(bg2Index=='2'){
          this.bg2Index='3'
          this.bg2show1=false
          this.bg2show2=false
          this.bg2show3=true
        }else{
          this.bg2Index='1'
          this.bg2show1=true
          this.bg2show2=false
          this.bg2show3=false
        }
      },
      
  },
  mounted(){
    if(document.body.clientWidth>450){
          this.indexShow=true
        }else{
          this.indexShow=false
          this.$nextTick(() => {
            let timer = setTimeout(() => { 
              if (timer) {
                clearTimeout(timer)
                // this.verScroll()
              }
            }, 0)
          })
        }
      
     window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth
        if(document.body.clientWidth>450){
          this.indexShow=true
        }else{
          this.indexShow=false
        }
      })()
    }
    window.addEventListener('scroll', this.handleScroll)
    let nav = sessionStorage.getItem('nav')
    this.$nextTick(() => {
            let timer = setTimeout(() => { 
              if (timer) {
                if(nav){
                    switch(nav){
                      case "index":{
                        this.toTop()
                        break
                      }
                      case "Bg3":{
                        this.toBg3()
                        break
                      }
                      case "Bg4":{
                        this.toBg4()
                        break
                      }
                      case "Bg5":{
                        this.toBg5()
                        break
                      }
                      case "Bg6":{
                        this.toBg6()
                        break
                      }
                    }
    }
              }
            }, 0)
          })
    
  },
  created(){
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/* 如果想让某个元素不使用自适应，只要把px写成px就行。 */
.index .footer{
  width: 100%;
  margin-top: 90px;
  height: 330px!important;
  background-image: url("../assets/bg_06.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 0;

}
.index .footer .copyright{
  margin-top: 30px;
  overflow: hidden;

}
.index .footer .copyright .left{
  float: left;
  text-align: left;
}
.index .footer .copyright .left .title1{
  font-family: PingFangSC-Semibold;
font-size: 14px;
color: #FFFFFF;
font-weight: 600;
}
.index .footer .copyright .left .title2{
font-family: PingFangSC-Regular;
font-size: 14px;
color: #848991;
margin-top: 4px;
cursor: pointer;
}
.index .footer .copyright .right{
  float: right;
  margin-top: -6px;
}
.index .footer .nav{
  margin-top: 110px;
}
.index .footer .navcon{
  font-family: PingFangSC-Regular;
font-size: 16px;
color: #FFFFFF;
text-align: center;
float: left;
width: 94px;
cursor: pointer;
}
.index .footer .navcon.long{
width: 109px;
}
.index .footer .navcon:hover{
  opacity: 0.5;
  color:#fff
}
.index .footer .navcon:first-child{
text-align: left;
width: 50px;
}

.index .footer .navline{
  width: 1px;
  height: 16px;
  display: block;
  float: left;
  background: #DBBA66;
  margin-top: 3.5px;
}
.index>>>.el-carousel{
  
}

.index>>>.el-carousel__button{
width: 40px;
height: 6px;
background: #F1F1F1;
opacity: 1;
cursor: pointer;
}
.index>>>.el-carousel__indicator.is-active button{
  background: #DBBA66;
}
.index>>>.el-carousel__mask{
  background-color: transparent;
  opacity: 0;
}
 .carousel-img {
    max-width: 100%;
    max-height: 100%;
  }

  
  .el-carousel__item:nth-child(2n) {
   
  }      
  
  .el-carousel__item:nth-child(2n+1) {
    
  }
.index{
 height: 100%;

} 
.index .el-fade-in-linear-leave-active{
  transition: opacity .5s linear;
  -webkit-transition: opacity .5s linear;
}
.index .el-fade-in-linear-enter-active{
transition: opacity .5s linear;
  -webkit-transition: opacity .5s linear;
}
.index .scrollbg{
  height: 80px;
}
.index .el-main{
  padding: 0;
    margin-top: -140px;

}
.index .background1{
  background-image: url("../assets/bg_02.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 0;
}
.index .background2{
  background-image: url("../assets/bg_03.png");
  height: 600px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 60% 0;
  position: relative;
  overflow: hidden;
}
.index .background3{
  height: 1800px;
  overflow: hidden;
  margin-top: -310px;
  background-image: url("../assets/bg_04.png");
   background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 200px;
  position: relative;
}
.index .map{
  width: 100%;
  height: 600px;
  background-image: url("../assets/bg_05.png");
   background-size: cover;
   background-position: 50% 0;
  background-repeat: no-repeat;
  position: relative;
  margin-top: 50px;
}
.index .logo{
  display: block;
  float: left;
  width: 200px;
  height: 60px;
 
}
.index .nav{
  width: 100%!important;
  height: 80px;
  overflow: hidden;
}
.index .logo img{
  width: 200px;
  height: 60px;
}
.index .el-header{
  height: 780px!important;
  width: 100%;
  line-height: 80px;
  background-image: url("../assets/bg_01.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 0;
  padding: 0;
  
  position: relative;
}

.index .container{
  width: 1080px;
  margin: 0 auto;
  position: relative;
}
.index .bg2{
  height: 400px;
  position: relative;
  
}
.index .bg2con{
  width: 240px;
  height: 380px;
  float: left;
  background: #FFFFFF;
box-shadow: 0 0 10px 0 rgba(0,0,0,0.10), 0 0 30px 0 rgba(0,0,0,0.10);
border-radius: 4px;
border-radius: 4px;
margin-right: 60px;
padding: 0 40px;
position: relative;
}
.index .bg2con .bg2conlogo{
  margin-top: 20px;
}
.index .bg2con .bg2contitle{
  font-family: PingFangSC-Semibold;
  font-weight: bold;
font-size: 20px;
color: #333333;
text-align: center;
}
.index .bg2con .bg2conbtn{
  background: #0B1525;
  width: 100px;
  height: 30px;
  position: absolute;
  bottom: 30px;
  left: 110px;
  font-family: PingFangSC-Regular;
font-size: 12px;
color: #FFFFFF;
letter-spacing: 0;
text-align: center;
line-height: 30px;
cursor: pointer;

}
.index .bg2con .bg2contxt{
  margin-top: 10px;
  font-family: PingFangSC-Regular;
font-size: 14px;
color: #333333;
text-align: justify;
}
.index .bg2con:last-child{
  margin-right: 0;
  float: right;
}
.index .bg3{
  margin-top: 100px;
  height: 830px;
}
.index .bg3 .bg3con{
  margin-top: 60px;
  position: relative;
}
.index .bg3 .bg3img{
  position: absolute;
  left: 0;
  width: 770px;
  height: 500px;
}
.index .bg3 .bg3img img{
  width: 770px;
  height: 500px;
}
.index .bg3 .bg3box{
  background: #FFFFFF;
box-shadow: 0 0 10px 0 rgba(0,0,0,0.10), 0 0 30px 0 rgba(0,0,0,0.10);
padding: 0 50px;
border-radius: 4px;
border-radius: 4px;
position: absolute;
right: 0;
top: 65px;
width: 340px;
height: 370px;
}
.index .bg3 .bg3box .bg3boxtitle{
  font-family: PingFangSC-Semibold;
  font-weight: 600;
font-size: 20px;
color: #333333;
margin-top: 60px;
text-align: left;
}
.index .bg3 .bg3box .bg3boxtxt{
  font-family: PingFangSC-Regular;
font-size: 14px;
color: #333333;
text-align: justify;
margin-top: 10px;
}
.index .bg3 .bg3box  .bg3boxbtn{
  border: 1px solid #333333;
  width: 100px;
  height: 30px;
  text-align: center;
  line-height: 30px;
 position: absolute;
 bottom: 120px;
 cursor: pointer;
}
.index .bg3 .bg3box .bg3boxtitle .line{
  width: 4px;
  height: 16px;
  background-color: #DBBA66;
  display: block;
  float: left;
  margin-top:6px;
  margin-right: 6px;
}
.index .bg3 .bg3box .togglebtn{
position: absolute;
bottom: 60px;
}
.index .bg3 .bg3box .togglebtn .toggletxt{
  float: left;
  font-family: AlibabaPuHuiTiB;
font-size: 16px;
color: #333333;
letter-spacing: 0;
}
.index .bg3 .bg3box .togglebtn .toggletxt span{
  font-family: AlibabaPuHuiTiL;
}
.index .bg3 .bg3box .togglebtn .toggleicon{
float: left;
margin-left: 55px;
background: #FFFFFF;
border: 1px solid #E5C27E;
border-radius: 2px;
border-radius: 2px;
padding-top: 0.5px;
}
.index .bg3 .bg3box .togglebtn img{
  width: 29px;
  height: 26px;
}
.index .bg3 .bg3box .togglebtn .toggleleft{
display: block;
cursor: pointer;
width: 29px;
height: 26px;

float: left;
}
.index .bg3 .bg3box .togglebtn .toggleright{
display: block;
cursor: pointer;
width: 29px;
height: 26px;
float: left;


}

.index .bg3title{
  font-family: SourceHanSerifCN-Heavy;
font-size: 30px;
color: #333333;
letter-spacing: 3px;
text-align: center;
font-weight: 600;
}
.index .bg3title img{
  width: 320px;
  height: 100px;
  margin: 0 auto;
}
.index .bg3stitle{
  font-family: TimesNewRomanPS-BoldMT;
font-size: 12px;
color: #E5C27E;
letter-spacing: 3px;
text-align: center;
margin-top: 4px;
}
.index .bg3txt{
  width: 750px;
  margin: 0 auto;
  margin-top: 20px;
  font-family: PingFangSC-Regular;
font-size: 14px;
color: #333333;
letter-spacing: 0;
text-align: center;
}
.index .bg4{
margin-top: 128px;
}
.index .bg5{
  margin-top: 128px;
  overflow: hidden;
}
.index .bg6{
  margin-top: -120px;
}
.index .bg7{
  height: 250px;
  margin-top: -130px;
}
.index .bg7con{
  background: #FFFFFF;
box-shadow: 0 0 10px 0 rgba(0,0,0,0.10), 0 0 30px 0 rgba(0,0,0,0.10);
border-radius: 4px;
border-radius: 4px;
width: 180px;
height: 200px;
padding: 0 30px;
overflow: hidden;
margin-right: 40px;
float: left;

}
.index .bg7con:last-child{
  margin-right: 0;
}
.index .bg7con img{
  max-width: 100%;
  max-height: 100%;
}
.index .bg7con .bg7logo{
  width: 80px;
  height: 80px;
  margin: 0 auto;
  margin-top: 20px;
}
.index .bg7con .bg7title{
  margin-top: 3px;
  font-family: PingFangSC-Semibold;
font-size: 16px;
color: #333333;
text-align: center;
font-weight: 600;
}
.index .bg7con .bg7txt{
  font-family: PingFangSC-Light;
font-size: 13px;
color: #333333;
text-align: center;
margin-top: 6px;
font-weight: 400;
}
.index .bg6 .bg6title{
  font-family: SourceHanSerifCN-Heavy;
font-size: 30px;
color: #333333;
letter-spacing: 3px;
text-align: center;
font-weight: 600;
}
.index .bg6 .bg6title img{
width: 320px;
height: 100px;
margin: 0 auto;
}

.index .bg5 .bg5title{
  font-family: SourceHanSerifCN-Heavy;
font-size: 30px;
color: #333333;
letter-spacing: 3px;
text-align: center;
font-weight: 600;
}
.index .bg5 .bg5title img{
  width: 320px;
  height: 100px;
  margin:0 auto
}
.index .bg5 .bg5con{
  width: 100%;
  height: 500px;
  margin: 60px auto;
}
.index .bg5 .bg5con img{
  max-width: 100%;
  max-height: 100%;
}
.index .bg4title{
  font-family: SourceHanSerifCN-Heavy;
  font-weight: 600;
font-size: 30px;
color: #FFFFFF;
letter-spacing: 3px;
text-align: center;
margin-top: 128px;
}
.index .bg4title img{
  width: 320px;
  height: 100px;
  margin: 0 auto;
}
.index .bg4stitle{
  margin-top: 4px;
  font-family: TimesNewRomanPS-BoldMT;
font-size: 12px;
color: #E5C27E;
letter-spacing: 3px;
text-align: center;
font-weight: 600;
}
.index .bg4stitle2{
  font-family: PingFangSC-Regular;
font-size: 14px;
color: #FFFFFF;
text-align: center;
margin-top: 20px;
}
.index .bg1txt{
  margin-top: 145px;
  display: block;
  overflow: hidden;
}
.index .bg1txt .bg1txtl{
  font-family: SourceHanSerifCN-Heavy;
font-size: 62px;
color: #fff;
text-align: left;
}
.index .bg1txt .bg1txts{
font-family: PingFangSC-Regular;
font-size: 18px;
color: #fff;
text-align: left;
line-height: 28px;
margin-top: 10px;
}
.index .bg1txt .button{
  width: 220px;
  height: 60px;
  margin-top: 46px;
  background-image: url("../assets/button.png");
  background-repeat: no-repeat;
  background-size: cover;
  font-family: PingFangSC-Medium;
font-size: 20px;
color: #08192F;
text-align: left;
line-height: 58px;
cursor: pointer;
}
.index .el-menu.el-menu--horizontal{
  border-bottom:none;
  background:transparent;
  width: 1080px;
  margin: 10px auto;
}
.index .el-menu--horizontal>.el-menu-item{
  font-family: PingFangSC-Regular;
font-size: 16px;
color: #FFFFFF;
text-align: center;
padding: 0 15px;
float: right;
}
.index .hr{
  border: 1px solid #FFFFFF!important;
border-radius: 4px;
border-radius: 4px;
width: 100px;
height: 40px;
line-height: 40px;
margin-top: 9px;
margin-left: 12px;


}
.index .el-menu--horizontal>.el-menu-item:hover{
  background-color: transparent;
  opacity: 0.5;
  color:#fff
}
.index .el-menu--horizontal>.el-menu-item.is-active{
  color: #fff;
  background-color: transparent;
  border-bottom: 1px solid #DBBA66;
}
.index .navActive{
position: fixed;
top: 0;
    background-color: #1b1b1b!important;
    transition: all 3s ease-out!important;
z-index: 100;

}
.index2 {
  width: 100%;

}
.index2 .wrapper1{
width: 100%;
overflow: hidden;
margin-top: 500px;
}
.index2 .wrapper1 .cont{
list-style: none;
white-space: nowrap;
text-align: center;
}
.index2 .wrapper1 .cont .cont-item{
position: relative;
display: inline-block;
margin-right: 20px;
width: 250px;
}
.index2 .wrapper1 .cont .cont-item .cont-img{
   overflow: hidden;
   width: 250px;
   height: 250px;
}
.index2 .wrapper1 .cont .cont-item .cont-img img{
  width: 100%;
}
.index2 .nav{
  width: 100%;
  background: transparent;
  height: 40px;
}
.index2 .nav .left{
  position: absolute;
  left: 0;
}
.index2 .nav .left img{
  width: 100px;
  height: 30px;
  margin-left: 10px;
  margin-top: 5px;
}
.index2 .nav .right{
  float: right;
}
.index2 .nav .right img{
  width: 20px;
  height: 20px;
  margin-right: 10px;
  margin-top: 10px;
}
.index2 .navActive2{
  background-color: #0B1525 ;
}
.index2 .navselect{
  width: 100%;
  height: 60px;
  background: #0B1525;
  line-height: 60px;
  font-family: PingFangSC-Regular;
font-size: 14px;
color: #FFFFFF;
text-align: left;
}
.index2 .navselect .van-icon-arrow{
color: #DBBA66;
display: inline-block;
margin-left: 14px;
margin-right: 6px;
}
.index2 .navselect .selecttxt{
 
}
.index2 .header{
  width: 100%;
  height: 300px;
  background-image: url("../assets/mobile/header@2x.png");
  background-size: 100%;
  background-repeat: no-repeat;
  padding-top: 80%;
  margin-top: -40px;
}
.index2 .aboutBtn{
  width:150px;
  height: 50px;
  display: block;
  position:absolute;
  top: 180px;
  left: 100px;
  cursor: pointer;
}
.index2 .con1{
  margin-top: -340px;
  height: 320px;

}
.index2 .con1 .van-swipe-item{
background:transparent;
}
.index2 .con1 .itemcon{
box-shadow: 0 0 5px 0 rgba(0,0,0,0.10), 0 0 15px 0 rgba(0,0,0,0.10);
border-radius: 4px;
border-radius: 4px;
height: 280px;
width: 280px;
margin: 0 auto;
margin-top: -30px;
background-color: #fff;
position: relative;
}
.index2 .con1 .itemcon .itemhead{
  margin: 0 auto;
  margin-top: 30px;
  font-family: PingFangSC-Semibold;
font-size: 18px;
color: #333333;
text-align: center;
height: 60px;
}
.index2 .con1 .itemcon .itemhead img{
  width: 60px;
  height: 60px;
  display: block;
  position: absolute;
  top: 30px;
  left: 62px;
}
.index2 .con1 .itemcon .itemhead .itemtitle{
  position: absolute;
  top: 48px;
  right: 76px;
  font-weight: 600;
}
.index2 .con1 .itemcon .itemtxt{
  position: absolute;
  width: 220px;
  left: 30px;
  top: 100px;
  font-family: PingFangSC-Regular;
font-size: 11px;
color: #333333;
text-align: justify;

}
.index2 .con1 .itemcon .itembtn{
  width: 100px;
  height: 30px;
  background: #0B1525;
  font-family: PingFangSC-Regular;
font-size: 12px;
color: #FFFFFF;
letter-spacing: 0;
text-align: center;
line-height: 30px;
position: absolute;
top: 220px;
left: 90px;
}
.index2 .con1 .first{
  margin-left: 40px;
}
.index2 .con1 .last{
  margin-right: 40px;
}
.index2 .con1 .second{
  width: 280px;
}
.index2 .con1 .van-swipe{
  height: 320px;
}
.index2>>>.van-swipe__indicator{
width: 20px;
height: 5px;
border-radius: 0;
background: #e2e2e2;
}
.index2>>>.van-swipe__indicator--active{
  background: #DBBA66;
}
.index2 .con2{
margin-top: 25px;
}
.index2 .con2 .van-swipe {
    height: 250px;
    margin-top: -50px;
}
.index2 .con2 .itemcon{
height: 210px;
background: #FFFFFF;
box-shadow: 0 0 5px 0 rgba(0,0,0,0.10), 0 0 15px 0 rgba(0,0,0,0.10);
border-radius: 4px;
border-radius: 4px;
width: 280px;
    margin: 0 auto;
    background-color: #fff;
    position: relative;
}
.index2 .con2 .line{
  background: #DBBA66;
  width: 3px;
  height: 11px;
  position: absolute;
  top: 38px;
  left:29px
}
.index2 .con2 .itemtitle{
  font-family: PingFangSC-Semibold;
font-size: 14px;
color: #333333;
position: absolute;
top: 34px;
left: 36px;
font-weight: 600;
}
.index2 .con2 .itemtxt{
  font-family: PingFangSC-Regular;
font-size: 11px;
color: #333333;
text-align: justify;
position: absolute;
top: 58px;
left: 29px;
width: 220px;
}
.index2 .con2 .itembtn{
  border: 1px solid #333333;
  position: absolute;
  top: 156px;
  left: 29px;
  width: 68px;
  height: 20px;
  line-height: 20px;
  font-size: 11px;
color: #333333;
text-align: justify;
font-family: PingFangSC-Regular;
text-align: center;
}
.index2 .con2 .first{
  margin-left: 40px;
}
.index2 .con2 .last{
  margin-right: 40px;
}
.index2 .con2 .title img{
  width: 200px;
  height: 40px;
  margin: 0 auto;
}
.index2 .con2 .title2{
  width: 300px;
  font-family: PingFangSC-Regular;
font-size: 11px;
color: #333333;
letter-spacing: 0;
text-align: center;
margin: 0 auto;
margin-top: 10px;
}
.index2 .con2 .con2bg img{
  width: 100%;
  height: 244px;
  margin-top: 30px;

}
.index2 .con3{
   width: 100%;
  height: 400px;
  background-image: url("../assets/mobile/bg@2x.png");
  background-size: 100%;
  background-repeat: no-repeat;
  margin-top: 30px;
}
.index2 .con3 .title img{
  width: 200px;
  height: 40px;
  margin: 0 auto;
  margin-top: 40px;
}

.index2 .con3 .title2{
  font-family: PingFangSC-Regular;
font-size: 11px;
color: #FFFFFF;
letter-spacing: 0;
text-align: center;
width: 300px;
margin: 0 auto;
margin-top: 10px;
}
.index2 .con3 .itemcon{
height: 194px;

width: 280px;
    margin: 0 auto;
   
    position: relative;
}
.index2 .con3 .itemcon img{
  width: 310px;
  height: 224px;
  position: absolute;
  left: -14px;
  top: -15px;
}
.index2 .con3 .first{
  margin-left: 40px;
}
.index2 .con3 .last{
  margin-right: 40px;
}
.index2 .con3 .van-swipe{
  height: 230px;
  margin-top: 28px;
}
.index2 .con4 .title img{
  width: 200px;
  height: 40px;
  margin: 0 auto;
  margin-top: 10px;
}
.index2 .con4 .title2{
  width: 300px;
  font-family: PingFangSC-Regular;
font-size: 11px;
color: #333333;
letter-spacing: 0;
text-align: center;
margin: 0 auto;
margin-top: 10px;
}
.index2 .con4 .con4bg{
  background: #E1D7C4;
  width: 100%;
  height: 120px;
  margin-top: 60px;
}
.index2 .con4 .copyright img{
  width: 310px;
  height: 210px;
  margin: 0 auto;
  margin-top: -165px;
}
.index2 .con5{
  margin-top: 40px;
}
.index2 .con5 .title img{
 width: 200px;
 height: 40px;
 margin: 0 auto;
 margin-bottom: 30px;
}
.index2 .con5 .con5row{
  width: 280px;
  margin: 0 auto;
}
.index2 .con5 .con5row .left{
  background: #FFFFFF;
box-shadow: 0 0 5px 0 rgba(0,0,0,0.10);
border-radius: 4px;
border-radius: 4px;
width: 135px;
height: 120px;
float: left;
position: relative;
}
.index2 .con5 .con5row .right{
  background: #FFFFFF;
box-shadow: 0 0 5px 0 rgba(0,0,0,0.10);
border-radius: 4px;
border-radius: 4px;
width: 135px;
height: 120px;
float: right;
position: relative;
}
.index2 .con5 .con5row .logo img{
  position: absolute;
  width: 40px;
  height: 40px;
  top: 16px;
  left: 47px;
}
.index2 .con5 .con5row .title{
  font-family: PingFangSC-Semibold;
font-size: 11px;
color: #333333;
text-align: center;
position: absolute;
top: 60px;
left: 46px;
font-weight: 600;
}
.index2 .con5 .con5row .txt{
  font-family: PingFangSC-Light;
font-size: 12px;
color: #333333;
text-align: center;
position: absolute;
top: 76px;
left: 0;

}
.index2 .con5 .con5row .center{
  position: relative;
  width: 120px;
  height: 40px;
  margin: 0 auto;
  word-break: break-all;
}
.index2 .con6 img{
  width: 100%;
  height: 200px;
  margin-top: 30px;
}
.index2 .footer{
     width: 100%;
  height: 130px;
  background-image: url("../assets/mobile/footer@2x.png");
  background-size: cover;
  background-repeat: no-repeat;
  margin-top: -5px;
  position: relative;
}
.index2 .footer img{
width: 100px;
height: 30px;
margin:0 auto;
margin-top: 20px;
}
.index2 .footer .name{
  font-family: PingFangSC-Semibold;
  font-weight: 600;
font-size: 7px;
color: #FFFFFF;
text-align: center;
margin-top: 15px;
}
.index2 .footer .copyright{
  font-family: PingFangSC-Semibold;
font-size: 7px;
color: #848991;
text-align: center;
margin-top: 3px;
}






@media screen and (min-width:400px) {
/* .index2 .header{
  background-image: url("../assets/mobile/header@3x.png");
  height: 320px;
} */
.index2 .aboutBtn{
  top: 210px;
  left: 130px;
}
}




</style>
